<template>
  <div :class="['aside-menu-wrapper', hideMenuClass]">
    <div class="aside-menu">
      <div class="items">
        <AsideMenuItem v-for="(route, i) in activeRoutes" :key="i" :index="'' + i" :route="route" @click="routeClick" />
      </div>
    </div>
    <div class="aside-menu-overlay" @click="TOGGLE_MENU(false)"></div>
  </div>
</template>

<script>
import AsideMenuItem from './components/AsideMenuItem'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    AsideMenuItem,
  },
  computed: {
    ...mapGetters(['menu', 'user', 'routesWithPermissions', 'isMobile']),
    routes() {
      return this.routesWithPermissions
    },
    activeRoutes() {
      return this.routes.filter(r => !(r.meta || {}).hidden)
    },
    hideMenuClass() {
      return !this.menu.open && 'hide-menu'
    },
  },
  methods: {
    ...mapMutations(['TOGGLE_MENU']),
    routeClick(route) {
      if (this.$route.name == route.name) return this.isMobile && this.TOGGLE_MENU(false)

      this.$router.push(route)
      if (this.isMobile) this.TOGGLE_MENU(false)
    },
  },
}
</script>

<style lang="scss">
@import '@styles';
.aside-menu-wrapper {
  $width: 280px;
  position: relative;
  display: flex;
  z-index: 19;

  .aside-menu {
    overflow-y: auto;
    height: 100%;
    flex: 0 0;
    padding: 1.8em 0em 1.8em 0.3em;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    min-width: $width;
    box-sizing: border-box;
    transition: all 300ms;

    @include themed() {
      background: t(aside-bg);
      color: t(aside-text);
    }

    .items {
      > *:not(:last-child) {
        margin-bottom: 0.5em;
      }
    }
  }
  .aside-menu-overlay {
    transition: all 300ms;
    background: rgba(19, 19, 19, 0.5);
    backdrop-filter: blur(2px);
  }
  &.hide-menu {
    pointer-events: none;
    .aside-menu {
      margin-left: -$width;
    }
    .aside-menu-overlay {
      pointer-events: none;
      background: rgba(0, 0, 0, 0);
      backdrop-filter: none;
    }
  }
  @media (max-width: $break-small) {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
}
</style>
